var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationsService } from 'app/applications/applications.service';
import { ServiceType } from 'app/core/service-type.model';
import { isNil } from 'app/core/validation';
import { DocumentsComponent } from 'app/documents/documents.component';
import { ConsumptionService } from 'app/services/consumption.service';
import { LimitsService } from 'app/services/limits.service';
import { RoutingService } from 'app/services/routing.service';
import { DialogEventEnum } from 'app/ui/dialog/dialog-event.enum';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UISnackBarService } from 'app/ui/snack-bar/snack-bar.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { UserService } from 'app/user/user.service';
import { forkJoin, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { SidebarSettingsService } from './sidebar-settings.service';
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(_applicationsService, _routingService, _consumptionService, _limitsService, _route, _dialogService, _sidebarSettingsService, _snackBarService, _userService, _userSettingsService) {
        this._applicationsService = _applicationsService;
        this._routingService = _routingService;
        this._consumptionService = _consumptionService;
        this._limitsService = _limitsService;
        this._route = _route;
        this._dialogService = _dialogService;
        this._sidebarSettingsService = _sidebarSettingsService;
        this._snackBarService = _snackBarService;
        this._userService = _userService;
        this._userSettingsService = _userSettingsService;
        this.activeServiceType = null;
        this.developersSectionIsHidden = true;
        this.documentsTypes = [
            {
                title: 'Invoices',
                type: 'invoices',
                serviceType: ServiceType.InvoiceCapture,
                isExpanded: false
            },
            {
                title: 'Other Documents',
                type: 'documents',
                serviceType: ServiceType.DocumentCapture,
                isExpanded: false
            }
        ];
        this.pageCount = 0;
        this.documentCount = 0;
    }
    SidebarComponent.prototype.expandDevelopersSection = function () {
        this.developersSectionIsHidden = !this.developersSectionIsHidden;
    };
    Object.defineProperty(SidebarComponent.prototype, "visible", {
        get: function () {
            return this._sidebarSettingsService.visible;
        },
        set: function (value) {
            this._sidebarSettingsService.visible = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarComponent.prototype, "serviceType", {
        get: function () {
            return this._route.url.indexOf('documents') === -1
                ? ServiceType.InvoiceCapture
                : ServiceType.DocumentCapture;
        },
        enumerable: true,
        configurable: true
    });
    SidebarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var url = this._route.routerState.snapshot.url;
        this.serviceTypeSubscription = this._userSettingsService.serviceType$.subscribe(function () {
            var showDevelopersSection = url.split('documents/').length > 1 || url.split('invoices/').length > 1;
            if (_this.activeServiceType !== _this.serviceType && !showDevelopersSection) {
                _this.developersSectionIsHidden = true;
            }
            else {
                _this.developersSectionIsHidden = false;
            }
            _this.activeServiceType = _this.serviceType;
        });
        this._subscription = this._userSettingsService.serviceType$
            .pipe(tap(function () { return (_this.demoApplications = null); }, (this.consumptionPercentage = null)), switchMap(function () { return timer(0, 7000); }), switchMap(function () { return _this._getConsumption(); }))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), limits = _b[0], bill = _b[1];
            var itemsLimit = _this._getItemsLimit(limits);
            _this.demoApplications = _this._getDemoApplicationsString(itemsLimit, bill);
            _this.consumptionPercentage = _this._getConsumptionPercentage(itemsLimit, bill);
            if ([ServiceType.DocumentCapture, ServiceType.InvoiceCapture].includes(_this.serviceType)) {
                _this.pageCount = bill.demo.pageCount;
                _this.documentCount = bill.demo.documentCount;
            }
            _this.limit = itemsLimit;
            _this.customApplicationsPages = bill.paid.pageCount;
            _this.customApplicationsDocuments = bill.paid.documentCount;
        });
        this._contactSubscription = this._dialogService.dialogEvents.subscribe(function (event) {
            if (event === DialogEventEnum.save) {
                _this._snackBarService.open(_this._contactTemplate);
            }
        });
        this._activatedRouteSubscription = this._routingService.routes.subscribe(function (route) {
            _this.activeDocumentsComponent = route.component === DocumentsComponent;
        });
    };
    SidebarComponent.prototype.showCustomApplicationBalanceReport = function () {
        return this._applicationsService
            .applications(this.serviceType)
            .filter(function (app) { return app.isCustomized; }).length;
    };
    SidebarComponent.prototype._getItemsLimit = function (limits) {
        if (this.serviceType === 'dc') {
            return limits.dc.pagesCount;
        }
        else {
            return limits.ic.pagesCount;
        }
    };
    SidebarComponent.prototype._getDemoApplicationsString = function (itemsLimit, bill) {
        return bill.demo.pageCount + " of " + itemsLimit + " trial pages";
    };
    SidebarComponent.prototype._getConsumptionPercentage = function (itemsLimit, bill) {
        return Math.round((100 * bill.demo.pageCount) / itemsLimit);
    };
    SidebarComponent.prototype._getConsumption = function () {
        return forkJoin([
            this._limitsService.getLimit(),
            this._consumptionService.getConsumption(this.serviceType),
        ]);
    };
    SidebarComponent.prototype.showProgressBar = function () {
        return !isNil(this.consumptionPercentage);
    };
    SidebarComponent.prototype.showStatistics = function (document) {
        if (this.isUsageReportPage()) {
            return false;
        }
        return this.demoApplications
            && this.serviceType === document.serviceType
            && this.showProgressBar()
            && !this._applicationsService.defaultApplication().isCustomized;
    };
    SidebarComponent.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._contactSubscription.unsubscribe();
        this._activatedRouteSubscription.unsubscribe();
    };
    SidebarComponent.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    SidebarComponent.prototype.userIsAdmin = function () {
        return this._userService.isAdmin();
    };
    SidebarComponent.prototype.userIsServiceAdmin = function () {
        return this._userService.isUserServiceAdmin();
    };
    SidebarComponent.prototype.showDevelopersSettings = function (serviceType) {
        switch (serviceType) {
            case 'ic': {
                return /invoices/.test(this._route.url);
            }
            case 'dc': {
                return /documents/.test(this._route.url);
            }
            default: {
                return false;
            }
        }
    };
    SidebarComponent.prototype.isUsageReportPage = function () {
        return !/documents|invoices/.test(this._route.url);
    };
    return SidebarComponent;
}());
export { SidebarComponent };
